<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" :disabled="isGeneralLoading"/>
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="value">
              <span id="input-text-mail-dialog-value-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{headerValue}}</span>
              <el-form-item prop="value">
                <el-input
                  type="text"
                  class="w-full"
                  v-model="form.value"
                  maxlength='100'
                  autocomplete="email"
                  aria-labelledby="input-text-mail-dialog-value-label"
                >
                  <template v-if="form.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo"
                      @clear="form.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'
import BaseDialogButton from './base/BaseDialogButton.vue'

import { i18n } from '@/i18n'

export default
{
  name: 'input-text-mail-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: ''
      },
      rules: {
        value: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
    }
  },
  mounted: async function () {
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form.value)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
